export enum EFeeFor {
	AGENT = "AGENT",
	OFFICE = "OFFICE",
}

export enum EFeePosition {
	TOP = "top",
	BOTTOM = "bottom",
}

export enum EFeeType {
	PERCENTAGE = "percentage",
	AMOUNT = "amount",
}

export enum EFeeCode {
	ssdf = "ssdf",
	royalty = "royalty",
	agent_development_fee = "agent_development_fee",
	agent_development_fee_pkp = "agent_development_fee_pkp",
}

export const DEFAULT_AGENT_FEE = [EFeeCode.agent_development_fee];
export const DEFAULT_OFFICE_FEE = [EFeeCode.ssdf, EFeeCode.royalty];

export enum EFeeFrequency {
	ONE_TIME = "one_time",
	PER_TRANSACTION = "per_transaction",
	MONTHLY = "monthly",
	QUARTERLY = "quarterly",
	PER_SEMESTER = "per_semester",
	EVERY_9_MONTHS = "every_9_months",
	YEARLY = "yearly",
}

export enum EFeeStatus {
	PUBLISH = "PUBLISH",
	UNPUBLISH = "UNPUBLISH",
}

export type MasterFeeProperties = {
	masterFeeId: string;
	feeFor: EFeeFor;
	feeName: string;
	feeCode?: EFeeCode;
	position: EFeePosition;
	type: EFeeType;
	ppn?: number;
	pph?: number;
	frequency: EFeeFrequency;
	status: EFeeStatus;
	createdByUserId?: string;
	createdByUserMeta?: any;
	createdAt: Date;
	updatedByUserId?: string;
	updatedByUserMeta?: any;
	updatedAt?: Date;
};

export type CreateMasterFeeProperties = Omit<
	MasterFeeProperties,
	| "masterFeeId"
	| "createdByUserId"
	| "createdByUserMeta"
	| "createdAt"
	| "updatedByUserId"
	| "updatedByUserMeta"
	| "updatedAt"
>;

export type ListMasterFeeQuery = {
	filterPosition?: string;
	filterFeeFor?: string;
	filterType?: string;
	filterFrequency?: string;
	filterStatus?: string;
	filterCreatedByUserId?: string;
	sort?: string;
};
